import { styled } from 'stitches.config'

export const FreezeDriedBoxRoot = styled('div', {})

export const HowItWorksWrapper = styled('div', {
  '& .how-does-fd-work-image-container': {
    width: '500px',
    aspectRatio: '1.5/1',

    '@bp3': {
      width: '657px',
      height: '438px',
      aspectRatio: 'unset',
    },
  },
})

export const CtaFooterWrapper = styled('div', {
  '& h2': {
    width: '100%',
    maxWidth: '360px',
  
    '@bp2': {
      maxWidth: '840px',
    },
  }
})